import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import Swal from 'sweetalert2';

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

//console.log(process.env.REACT_APP_BASE_URL)

export const fetchAllBackyardMedia = createAsyncThunk(
  'backyard/fetchAll',
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/backyard/fetch`, {
        params: { page, limit },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);


export const insertBackyardMedia = createAsyncThunk(
  'backyard/insert',
  async (data, { rejectWithValue }) => {
    //console.log(data,"datadata")
    const formdata = new FormData();
    if (Array.isArray(data?.video)) {
      data.video.forEach((url, index) => {
        formdata.append(`fileurl`, url);
      });
    } else {
      formdata.append("images", data?.video);
    }
    try {
      const response = await axios.post(`${API_BASE_URL}/backyard/insert`, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      Swal.fire({ icon: 'success', title: 'Success!', text: 'Media uploaded successfully.' });
      return response.data;
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Oops...', text: error.response?.data?.message || 'Something went wrong!' });
      return rejectWithValue(error.response?.data);
    }
  }
);


export const editBackyardMedia = createAsyncThunk(
  'backyard/edit',
  async (data, { rejectWithValue }) => {
    const formdata = new FormData();
    if (Array.isArray(data?.images)) {
      data.images.forEach((image, index) => {
        formdata.append(`images[${index}]`, image);
      });
    } else {
      formdata.append("images", data?.images);
    }
    try {
      const response = await axios.put(`${API_BASE_URL}/backyard/edit/${data?.id}`, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      Swal.fire({ icon: 'success', title: 'Success!', text: 'Backyard media updated successfully.' });
      return response.data;
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Oops...', text: error.response?.data?.message || 'Something went wrong!' });
      return rejectWithValue(error.response?.data);
    }
  }
);

// Delete Backyard Media
export const deleteBackyardMedia = createAsyncThunk(
  'backyard/delete',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/backyard/delete/${id}`, {
        headers: { Authorization: `Bearer ${Cookies.get('token')}` },
      });
      Swal.fire({ icon: 'success', title: 'Deleted!', text: 'Backyard media has been deleted successfully.' });
      return response.data;
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Oops...', text: error.response?.data?.message || 'Failed to delete backyard media.' });
      return rejectWithValue(error.response?.data);
    }
  }
);
